import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-gen-ai-powered-talent-aquisition',
  templateUrl: './gen-ai-powered-talent-aquisition.component.html',
  styleUrls: ['./gen-ai-powered-talent-aquisition.component.css']
})
export class GenAiPoweredTalentAquisitionComponent {
  isBrowser:boolean=false;
  constructor(
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/genai-powered-talentacquisition-candidate-profiling-and-job-fit-analysis/"
  },
  "headline": "Gen AI Powered Talent Acquisition for Candidate Profiling and Job-Fit Analysis",
  "description": "The high demand for top talent in today's job market challenges recruiters to efficiently find and screen qualified candidates among numerous applicants, a task that's both time-consuming and prone to missing ideal hires.",
  "image": "https://mitresource.com/assets/images/blogs/GenAI-Powered.webp",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-05-30"
}`;
   
    this._renderer2.appendChild(this._document.head, script);

if(this.isBrowser){     
  AOS.init({disable: 'mobile'});
}
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  scrollToSection(sectionId: string) {
    if(this.isBrowser){ 
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }}
   
  }
 

  baseUrl = Constants.baseUrl;

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Gen AI Powered Talent Acquisition for Candidate Profiling and Job-Fit Analysis');

    this.metaService.addTags([
      { name: 'description', content: 'The high demand for top talent in today\'s job market challenges recruiters to efficiently find and screen qualified candidates among numerous applicants, a task that\'s both time-consuming and prone to missing ideal hires.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Gen AI Powered Talent Acquisition for Candidate Profiling and Job-Fit Analysis' },
      { property: 'og:url', content: 'https://mitresource.com/genai-powered-talentacquisition-candidate-profiling-and-job-fit-analysis/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/GenAI-Powered.webp' },
      { property: 'og:description', content: 'The high demand for top talent in today\'s job market challenges recruiters to efficiently find and screen qualified candidates among numerous applicants, a task that\'s both time-consuming and prone to missing ideal hires.' },
    ]);
  }
}
